exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_object-pie.js
// module id = 124
// module chunks = 1 2 3